import {AppState} from '../store';

export const getAdmin = (state: AppState) => state.admin;

export const getAdminData = (state: AppState) => state.admin.data;

export const getAdminIsLoading = (state: AppState) => state.admin.isLoading;

export const getAdminIsSaving = (state: AppState) => state.admin.isSaving;
